import { NoddiSpinner } from '../NoddiSpinner';

export const NoddiCircularLoader = ({
  className,
  loadingText,
  size,
  textClassName
}: {
  className?: string;
  loadingText?: string;
  size?: 'small' | 'medium' | 'large';
  textClassName?: string;
}) => (
  <NoddiSpinner size={size ?? 'medium'} className={className}>
    <span className={textClassName}>{loadingText ?? 'Loading'}...</span>
  </NoddiSpinner>
);
